(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomCaseTypeAttributeDetailController', CustomCaseTypeAttributeDetailController);

    CustomCaseTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomCaseTypeAttribute'];

    function CustomCaseTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomCaseTypeAttribute) {
        var vm = this;

        vm.customCaseTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customCaseTypeAttributeUpdate', function(event, result) {
            vm.customCaseTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
